export default {"src":"/_next/static/media/po-finance.48b70d2c.svg","height":432,"width":552};